let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i0zNK")).then(() => parcelRequire('fK2A4'));